<template>
  <div
    class="justify-content-sm-center justify-content-start single-items text-center"
  >
    <div class="currency-area">
      <div class="currency-item">
        <div class="d-flex flex-column flex-sm-row">
          <div
            class="align-items-center d-flex flex-row pt-0 pt-sm-0 ml-3 ml-sm-0"
          >
            <span
              class="icon arrow-market-direction"
              :class="currentChange == 0 ? ['d-none', 'd-sm-inline-block'] : []"
            >
              <icon-up v-if="currentChange > 0" />
              <icon-down v-else-if="currentChange < 0" />
              <icon-down v-else style="opacity: 0;" />
            </span>

            <div
              class="high-text h4"
              :class="[
                marketClosed
                  ? 'text-black'
                  : currentChange > 0
                  ? 'text-primary'
                  : currentChange < 0
                  ? 'text-red'
                  : 'text-black',
              ]"
              :style="{
                'font-size': fontSize,
              }"
            >
              {{ currentPrice | financial }}
              <span class="right-text h6">
                {{ change > 0 ? '+' : '' }}{{ change | financial }}
                <span class="d-lg-block">{{
                  changePercent | percent
                }}</span></span
              >
            </div>
            <span class="line-br d-none d-sm-inline-block"></span>
          </div>

          <div
            class="align-items-center d-flex flex-row pt-2 pt-sm-0  pl-3 pl-sm-0"
          >
            <div class="block-text text-black d-none d-sm-block">
              {{ $t('header.market.fundamental') }}
              <span class="d-block">{{ $t('header.market.price') }}:</span>
            </div>
            <div class="block-text small-fund-price d-block d-sm-none mr-1">
              {{ $t('header.market.fundamentalFull') }}
              {{ $t('header.market.price') }}:
            </div>

            <div
              class="low-text text-black h4"
              :style="{ 'font-size': fontSize }"
            >
              <template v-if="!underReview">
                {{ fundamentalPrice | financial }}
                <span
                  class="ml-1 d-none d-sm-block"
                  :class="[
                    marketClosed
                      ? ''
                      : changeFundPercent >= 0
                      ? 'text-primary'
                      : 'text-red',
                  ]"
                  :style="{
                    'font-size': fontSize,
                    color: marketClosed ? '#8a8a8a' : undefined,
                  }"
                  >({{ changeFundPercent | percent }})</span
                >
                <span
                  class="ml-1 d-block d-sm-none"
                  :class="[
                    marketClosed
                      ? ''
                      : changeFundPercent >= 0
                      ? 'text-primary'
                      : 'text-red',
                  ]"
                  :style="{
                    color: marketClosed ? '#8a8a8a' : undefined,
                  }"
                  >{{ changeFundPercent | percent }}</span
                >
              </template>
              <template v-else>
                {{ $t('header.market.underReview') }}
              </template>
            </div>
            <span
              class="ml-3 faq-icon collapsed title-question-icon"
              @click.prevent="toggleHelp()"
            >
              <icon-question />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import filters from '@/utils/filters'

import iup from '@/components/icons/up'
import idown from '@/components/icons/down'
import iquestion from '@/components/icons/question'

export default {
  components: {
    'icon-up': iup,
    'icon-down': idown,
    'icon-question': iquestion,
  },
  filters: {
    percent: filters.percentWithPlus,
    financial: filters.financial,
  },
  computed: {
    ...mapGetters({
      change: 'market/change',
      changePercent: 'market/changePercent',
      changeFundPercent: 'market/changeFundPercent',
    }),
    ...mapState('market', {
      currentPrice: (state) => state.currentPrice,
      lastPrice: (state) => state.lastPrice,
      fundamentalPrice: (state) => state.fundamentalPrice,
      lastDayPrice: (state) => state.lastDayPrice,
      marketClosed: (state) => !state.trading,
    }),
    fontSize() {
      if (this.underReview) return '1.66rem'
      const curPrLen = String(filters.financial(this.currentPrice)).length,
        fundPrLen = String(filters.financial(this.fundamentalPrice)).length
      if (curPrLen > 7 || fundPrLen > 7) return '1.66rem' //'25px'
      if (curPrLen > 6 || fundPrLen > 6) return '1.87rem' //'28px'
      return '2.5rem' //'32px'
    },
    currentChange() {
      return this.currentPrice - this.lastPrice
    },
    underReview() {
      return this.$store.state.ticker.priceUnderReview
    },
  },
  methods: {
    toggleHelp() {
      this.$store.commit('layout/updateModal', {
        modal: 'help',
        show: true,
        title: this.$t('modals.references.fundamentalPrice.title'),
        content: this.$t('modals.references.fundamentalPrice.content'),
        subtitle: this.$t('modals.messages.reference'),
      })
    },
  },
}
</script>

<style lang="scss">
.text-black {
  color: #000 !important;
}
span.ml-3.title-question-icon {
  margin: auto 0;
}
.arrow-market-direction > svg {
  max-width: unset;
}
</style>
